/* VANTEK · Envío Express (sameday) · verificador de comuna
   - Pop-up accesible (<dialog>) creado una sola vez en <body>.
   - Prioridad de comuna: 1) elegida/detectada y guardada por el cliente, 2) dirección predeterminada del cliente con sesión, 3) sin dato.
   - "Usar mi ubicación": pide permiso solo al tocar el botón; ubica la comuna con el mapa assets/rm-comunas.json (sin servicios externos).
   - Config leída de <script type="application/json" data-vt-sameday-config> (viene del metaobjeto "Configuración Envío Express"). */
(function () {
  if (window.__vtSameday) return;
  window.__vtSameday = true;

  var KEY = 'vt_comuna';
  var COMUNAS = ["Alhué","Buin","Calera de Tango","Cerrillos","Cerro Navia","Colina","Conchalí","Curacaví","El Bosque","El Monte","Estación Central","Huechuraba","Independencia","Isla de Maipo","La Cisterna","La Florida","La Granja","La Pintana","La Reina","Lampa","Las Condes","Lo Barnechea","Lo Espejo","Lo Prado","Macul","Maipú","María Pinto","Melipilla","Ñuñoa","Padre Hurtado","Paine","Pedro Aguirre Cerda","Peñaflor","Peñalolén","Pirque","Providencia","Pudahuel","Puente Alto","Quilicura","Quinta Normal","Recoleta","Renca","San Bernardo","San Joaquín","San José de Maipo","San Miguel","San Pedro","San Ramón","Santiago","Talagante","Tiltil","Vitacura"];
  var ALIAS = { 'santiago centro': 'Santiago', 'stgo': 'Santiago', 'stgo centro': 'Santiago', 'til til': 'Tiltil', 'pac': 'Pedro Aguirre Cerda', 'est central': 'Estación Central' };

  function norm(t) { return String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  var CANON = {}; COMUNAS.forEach(function (c) { CANON[norm(c)] = c; });
  function toComuna(t) { var n = norm(t); if (ALIAS[n]) return ALIAS[n]; return CANON[n] || null; }
  function esc(t) { return String(t).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }

  var cfg = null, cov = {}, dlg, sel, res, geoBtn, geoMsg, mapPromise = null;

  function readConfig() {
    var el = document.querySelector('script[data-vt-sameday-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getSaved() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function setSaved(c) { try { c ? localStorage.setItem(KEY, c) : localStorage.removeItem(KEY); } catch (e) {} }

  /* estado: {comuna, fuente} | {fueraRM:true} | null */
  function initialState() {
    var s = toComuna(getSaved());
    if (s) return { comuna: s, fuente: 'guardada' };
    var cl = cfg && cfg.cliente;
    if (cl && (cl.city || cl.province)) {
      if (cl.province && cl.province !== 'RM') return { fueraRM: true, fuente: 'direccion' };
      var c = toComuna(cl.city);
      if (c) return { comuna: c, fuente: 'direccion' };
    }
    return null;
  }

  function covered(c) { return !!cov[norm(c)]; }

  function paint(state) {
    var badges = document.querySelectorAll('[data-vt-comuna-badge]');
    var txt = '', no = false;
    if (state && state.comuna) { var ok = covered(state.comuna); txt = ok ? '✓ Envío Express a ' + state.comuna : state.comuna + ': despacho estándar'; no = !ok; }
    else if (state && state.fueraRM) { txt = 'Tu dirección: despacho estándar'; no = true; }
    for (var i = 0; i < badges.length; i++) { badges[i].textContent = txt; badges[i].classList.toggle('is-no', no); }
    if (!res) return;
    if (state && state.comuna) {
      var yes = covered(state.comuna);
      res.className = 'vt-comuna__result ' + (yes ? 'is-yes' : 'is-no');
      res.innerHTML = yes
        ? '<strong>Sí, tenemos Envío Express a ' + esc(state.comuna) + '.</strong>Compra antes de las ' + esc(cfg.hora || '12:00') + ' y recíbelo hoy.'
        : '<strong>Por ahora el Envío Express no llega a ' + esc(state.comuna) + '.</strong>' + esc(cfg.sinCobertura || 'Tu pedido llegará con despacho estándar.');
    } else if (state && state.fueraRM) {
      res.className = 'vt-comuna__result is-no';
      res.innerHTML = '<strong>Tu dirección registrada está fuera de la Región Metropolitana.</strong>' + esc(cfg.sinCobertura || 'Tu pedido llegará con despacho estándar.');
    } else { res.className = 'vt-comuna__result'; res.innerHTML = ''; }
  }

  var current = null;
  function setState(s, persist) {
    current = s;
    if (sel) sel.value = s && s.comuna ? s.comuna : '';
    if (persist) setSaved(s && s.comuna ? s.comuna : '');
    paint(s);
  }

  var TRUCK = '<svg viewBox="0 0 64 30" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="1" y1="9" x2="13" y2="9"/><line x1="4" y1="14.5" x2="14" y2="14.5"/><line x1="1" y1="20" x2="12" y2="20"/></g><g fill="none" stroke="currentColor" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round"><path d="M17 4.5h25v18H17z"/><path d="M42 10h9.5l6.5 7.5v5H42"/><path d="M45 12.5h5.5l3.5 4H45z"/><circle cx="24" cy="24" r="3.6" fill="#1f22a6"/><circle cx="50" cy="24" r="3.6" fill="#1f22a6"/></g></svg>';

  function buildDialog() {
    dlg = document.createElement('dialog');
    dlg.className = 'vt-comuna';
    dlg.setAttribute('aria-labelledby', 'vt-comuna-title');
    var opts = '<option value="">Selecciona tu comuna</option>' + COMUNAS.map(function (c) { return '<option value="' + esc(c) + '">' + esc(c) + '</option>'; }).join('');
    dlg.innerHTML =
      '<div class="vt-comuna__head">' + TRUCK + '<h3 id="vt-comuna-title">¿Llega Envío Express a tu comuna?</h3>' +
      '<button type="button" class="vt-comuna__close" data-vt-comuna-close aria-label="Cerrar">×</button></div>' +
      '<div class="vt-comuna__body">' +
      '<label for="vt-comuna-select">Comuna (Región Metropolitana)</label>' +
      '<select id="vt-comuna-select">' + opts + '</select>' +
      '<button type="button" class="vt-comuna__geo" id="vt-comuna-geo"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M12 2v3M12 19v3M2 12h3M19 12h3"/><circle cx="12" cy="12" r="6" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="2" fill="currentColor"/></svg><span>Usar mi ubicación</span></button>' +
      '<p class="vt-comuna__geo-msg" id="vt-comuna-geo-msg" role="status" aria-live="polite"></p>' +
      '<div class="vt-comuna__result" id="vt-comuna-result" role="status" aria-live="polite"></div>' +
      '<p class="vt-comuna__fine">Compra antes de las ' + esc(cfg.hora || '12:00') + ' para recibir hoy. El costo y la fecha final se confirman en el checkout al ingresar tu dirección.</p>' +
      '</div>';
    document.body.appendChild(dlg);
    sel = dlg.querySelector('#vt-comuna-select');
    res = dlg.querySelector('#vt-comuna-result');
    geoBtn = dlg.querySelector('#vt-comuna-geo');
    geoMsg = dlg.querySelector('#vt-comuna-geo-msg');

    sel.addEventListener('change', function () {
      geoMsg.textContent = '';
      setState(sel.value ? { comuna: sel.value, fuente: 'manual' } : null, true);
    });
    dlg.querySelector('[data-vt-comuna-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    if (!('geolocation' in navigator)) geoBtn.hidden = true;
    geoBtn.addEventListener('click', locate);
  }

  /* ---- Mapa y geolocalización ---- */
  function decodeRing(str) {
    var pts = str.split(' '), x = 0, y = 0, out = new Array(pts.length);
    for (var i = 0; i < pts.length; i++) { var d = pts[i].split(','); x += +d[0]; y += +d[1]; out[i] = [x / 1e4, y / 1e4]; }
    return out;
  }
  function loadMap() {
    if (!mapPromise) {
      mapPromise = fetch(cfg.mapUrl, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('map'); return r.json(); }).then(function (j) {
        var list = [];
        Object.keys(j.c).forEach(function (name) { list.push({ n: name, polys: j.c[name].map(function (p) { return p.map(decodeRing); }) }); });
        return list;
      });
      mapPromise.catch(function () { mapPromise = null; });
    }
    return mapPromise;
  }
  function inRing(x, y, r) { var c = false; for (var i = 0, j = r.length - 1; i < r.length; j = i++) { var xi = r[i][0], yi = r[i][1], xj = r[j][0], yj = r[j][1]; if (((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) c = !c; } return c; }
  function inPoly(x, y, p) { if (!inRing(x, y, p[0])) return false; for (var k = 1; k < p.length; k++) if (inRing(x, y, p[k])) return false; return true; }
  function findComuna(list, lng, lat) { for (var i = 0; i < list.length; i++) for (var p = 0; p < list[i].polys.length; p++) if (inPoly(lng, lat, list[i].polys[p])) return list[i].n; return null; }

  function locate() {
    geoBtn.disabled = true; geoMsg.textContent = 'Buscando tu ubicación…';
    var mapP = loadMap();
    navigator.geolocation.getCurrentPosition(function (pos) {
      mapP.then(function (list) {
        geoBtn.disabled = false;
        var c = findComuna(list, pos.coords.longitude, pos.coords.latitude);
        if (c) { setState({ comuna: c, fuente: 'gps' }, true); geoMsg.textContent = 'Detectamos que estás en ' + c + '. Si tu despacho es en otra comuna, cámbiala arriba.'; }
        else { geoMsg.textContent = 'Tu ubicación está fuera de la Región Metropolitana. El Envío Express solo opera en comunas de la RM.'; }
      }).catch(function () { geoBtn.disabled = false; geoMsg.textContent = 'No pudimos cargar el mapa de comunas. Selecciona tu comuna en la lista.'; });
    }, function (err) {
      geoBtn.disabled = false;
      geoMsg.textContent = err && err.code === 1 ? 'No diste permiso de ubicación. Puedes elegir tu comuna en la lista.' : 'No pudimos obtener tu ubicación. Elige tu comuna en la lista.';
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
  }

  function open() { if (!dlg) return; if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', ''); sel.focus(); }

  function init() {
    cfg = readConfig();
    if (!cfg) return;
    (cfg.comunas || []).forEach(function (c) { cov[norm(c)] = true; });
    buildDialog();
    setState(initialState(), false);
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-vt-comuna-open]');
      if (t) { e.preventDefault(); open(); }
    });
    /* La ficha re-renderiza el bloque de precio al cambiar de variante: repintar el resultado */
    document.addEventListener('afterVariantChanged', function () { setTimeout(function () { paint(current); }, 0); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
